export default {
  token: null,
  isAuthenticated: false,
  expiresIn: null,
  loading: false,
  config: null,
  key: null,
};
